import {APP_MESSAGES} from "./enums/enums";
import {ICondition} from "./interfaces/condition.definition";
import {IDocument} from "./interfaces/document.definition";
import {ILocalesArray, ILocalesItem} from "./interfaces/locales-array.definition";
export interface IGoPageConfig {
  name:string;
  categories:string[];
  components:string[];
}


export interface ILock {
  _id: string;
  started: number;
  timeout: number;
}


export interface IConvertedDictEntry {
  key: string|number;
  value: string|number;
}


export interface IKeyValueItem {

}


export interface IRemoteLockResult {
  result: boolean;
  user?:User;
  timeout?: number;
}


export interface ILotteryRewardGroupsItem {
  worth: number;
  isFat: boolean;
  rewardsArray: IRewardsArrayItem[];
}

export interface IRewardsArrayItem {
  reward: IConvertedDictEntry[];
}


// ======================================================
//              PAGE CONFIG
// ======================================================
export class IPageConfig {
  title:string;
  subtitle?:string;
  listConfig:IListConfig;
}


export interface IListConfig {
  type:string;
  subtypes?: string[];
  label:string;
  search:ISearchParam[];
  filter:ISearchParam[]|null;
  database_renameMe?:string;
}


export interface ISearchParam {
  property:string;
  type:string;
  value:any;
  label?:string;
  locales?:ILocalesItem[];
}

export interface ISortParam {
  property:string;
  order:number; //-1 = descending, 1 = ascending
}
// ======================================================



export interface ILoadChunkResult {
  count:number;
  documents:IDocument[];
  offset:number;
}


export interface ISearchItem {
  _id:string;
  id:number;
  _type:string;
  locales:any[];
  category?:string;
  codeName?:string;
}

export interface IEnumListEntry {
  id:number|string;
  label:string
}


export interface IAdsSettings {
  defaultOrder:any;
  geos:any[];
  ISgeos:any[];
  YANgeos:any[];
  waterfallEnabled:any;
  ironSourceEnabled:any;
  YANEnabled:any;
}

export interface IWorkplaceLevelSettings {
  freeSlots: number;
  "productions": number[];
}

export interface IAction {
  restrictions:object;
  accelerateCost:number;
  time:number;
  id:number;
  workers:number;
  type:number;
  spendings:object[];
  reward:object[];
}


export interface IMarketTemplate {
  restrictions:object;
  id:number;
  name:string;
  min:number;
  max:number;
  powerKoeff:number;
  chance:number;
  superProfitChance:number;
  superProfitKoeff:number;
}

export interface IQuestRewardTemplate {
  id:number;
  slotsCount:number;
  name:string;
}


export interface IObjListEntry {
  id:number;
  lvl:number;
  cmp:string;
}

export interface User {
  locale:string;
  access:string;
  displayName:string;
  emails:string[];
  id:string;
}

export interface IOrdersRestrictionsGroup extends IDocument{
  rate:number;
}


export declare interface INotifier {
  notifyParent():void;
}


export class AppMessage {
  constructor(public type:APP_MESSAGES,
              public content:any) {
  }
}



// todo: IRestriction интерфейс для "преобразованного" рестикшена



// WEBPACK FOOTER //
// /opt/app/develop/src/app/definitions.ts